export default __webpack_public_path__ + "static/media/shop4.ae10415b.jpg";